import axios from "axios";
import { getHeader, getToken, deleteCookie } from "@/helpers/functions";

const header = getHeader(getToken("ifragasatt_cookie"));

const state = {
  myProfile: {},
  userIsBlocked: false,
  visitedUser: {}
};

const getters = {
  myProfile: state => state.myProfile,
  visitedUser: state => state.visitedUser,
  userIsBlocked: state => state.userIsBlocked,
  isLoggedIn: state => state.myProfile.userId !== 0
};

const mutations = {
  setMyProfile: (state, payload) => (state.myProfile = payload),
  setVisitedUser: (state, payload) => (state.visitedUser = payload),
  setUserIsBlocked: (state, payload) => (state.userIsBlocked = payload),
  setNewProfileInfo: (state, payload) => {
    state.myProfile.description = payload.description;
    state.myProfile.imageRotation = payload.imageRotation;
    state.myProfile.profilePicture = payload.profilePicture;
  }
};

const actions = {
  getMyProfile({ commit, dispatch }) {
    const url = `${process.env.VUE_APP_MY_PROFILE}`;
    dispatch("setIsLoading", true);

    axios
      .get(url, header)
      .then(res => {
        commit("setMyProfile", {
          countryCode: res.data.countryCode,
          createdAt: res.data.createdAt,
          description: res.data.description,
          email: res.data.email,
          firstName: res.data.firstName,
          imageRotation: res.data.imageRotation,
          lastName: res.data.lastName,
          profilePicture: res.data.profilePicture,
          userId: res.data.userId,
          userSlug: res.data.userSlug,
          numComments: res.data.numComments,
          numRemoved: res.data.numRemovedComments,
          isDirektUser: res.data.direktUser,
          isModOrAdmin: res.data.modAdmin,
          hasPassword: res.data.hasPassword
        });

        if (res.data.blocks) dispatch("setBlocks", res.data.blocks);
      })
      .catch(err => {
        console.error(err);
        dispatch("showToast", { message: "errors.PROFILE_FETCH_FAILED", type: "error" });
      })
      .finally(() => dispatch("setIsLoading", false));
  },
  getVisitedProfile({ commit, dispatch }) {
    const params = new URLSearchParams(window.location.search);
    const slug = params.get("slug");
    const alias = params.get("isalias");
    const url = `${process.env.VUE_APP_MY_PROFILE}?slug=${slug}&isalias=${alias}&pageSize=3&offset=0`;
    dispatch("setIsLoading", true);

    axios
      .get(url, header)
      .then(res => {
        commit("setVisitedUser", {
          firstName: res.data.firstName,
          lastName: res.data.lastName,
          name: res.data.name,
          description: res.data.description,
          createdAt: res.data.createdAt,
          numComments: res.data.numComments,
          profilePicture: res.data.profilePicture,
          slug: res.data.userSlug || res.data.slug
        });

        if (res.data.comments) {
          dispatch("setVisitedComments", res.data.comments);
        }
      })
      .catch(err => {
        console.error(err);
        dispatch("showToast", { message: "errors.VISITED_FETCH_FAILED", type: "error" });
      })
      .finally(() => {
        dispatch("setIsLoading", false);
      });
  },
  updateProfile({ commit, dispatch }, payload) {
    const url = `${process.env.VUE_APP_MY_PROFILE}`;
    dispatch("setIsLoading", true);

    axios
      .put(url, payload, header)
      .then(() => {
        commit("setNewProfileInfo", payload);
      })
      .catch(err => {
        console.error(err);
        dispatch("showToast", { message: "errors.PROFILE_UPDATE_FAILED", type: "error" });
      })
      .finally(() => dispatch("setIsLoading", false));
  },
  resetPassword({ dispatch }, payload) {
    const url = `${process.env.VUE_APP_RESET_PASSWORD}?email=${payload.email}&languageCode=${payload.languageCode}`;
    dispatch("setIsLoading", true);

    axios
      .get(url, header)
      .then(() => {
        dispatch("showToast", { message: "settings.PASSWORD_EMAIL_SUCCESS", type: "success" });
      })
      .catch(err => {
        console.error(err);
        dispatch("showToast", { message: "error.RESET_PASSWORD_FAILED", type: "error" });
      })
      .finally(() => dispatch("setIsLoading", false));
  },
  signOutUser({ dispatch, commit }) {
    const url = `${process.env.VUE_APP_SIGNUPAPI_URL}/signup/logout`;
    dispatch("setIsLoading", true);

    axios
      .put(url, { accessToken: getToken("ifragasatt_cookie") }, header)
      .then(res => {
        if (res.status == 200) console.log("AccessToken deleted");
      })
      .catch(err => {
        console.log("Error deleting token", err);
      })
      .finally(() => {
        commit("setMyProfile", {});
        dispatch("setIsLoading", false)
        deleteCookie("ifragasatt_cookie");
        window.location.href = process.env.VUE_APP_SIGNUP_ROUTE;
      });
  },
  closeAccount({ dispatch }) {
    const url = `${process.env.VUE_APP_MY_PROFILE}`;
    dispatch("setIsLoading", true);

    axios
      .delete(url, header)
      .then(() => {
        dispatch("showToast", { message: "settings.CLOSE_ACCOUNT_SUCCESS", type: "success" });
      })
      .then(() => {
        setTimeout(() => {
          dispatch("signOutUser");
        }, 3000);
      })
      .catch(err => {
        dispatch("showToast", { message: "settings.CLOSE_ACCOUNT_FAILED", type: "error" });
        console.error(err);
      })
      .finally(() => {
        dispatch("setIsLoading", false);
      });
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
